

var _directive = require('./directive');

var _locale = require('../locale');

(0, _directive.$registerDirective)('feature', function () {
    return {
        restrict: 'A',
        transclude: true,
        scope: {},
        template: '<span ng-if="enabled()" ng-transclude></span>',
        link: function link($scope, element, attr) {
            $scope.enabled = function () {
                return (0, _locale.$feature)(attr.feature);
            };
        }
    };
});

(0, _directive.$registerDirective)('unless-feature', function () {
    return {
        restrict: 'A',
        transclude: true,
        scope: {},
        template: '<span ng-if="!enabled()" ng-transclude></span>',
        link: function link($scope, element, attr) {
            $scope.enabled = function () {
                return (0, _locale.$feature)(attr.unlessFeature);
            };
        }
    };
});

_directive.$registerDirective;

_locale.$feature;


/*****************
 ** WEBPACK FOOTER
 ** ./components/squid/dist/ng/feature.js
 ** module id = 139
 ** module chunks = 1
 **/